module.exports = __webpack_public_path__ + "img/container5L.35ab59cd.png";